export default __webpack_public_path__ + "static/media/Header_logo.5481476c.png";